export const setting = {
  manylikeRequirement: 10,
  medalLevels: [5, 10, 20, 50, 100],
};
